import config from 'config'
import lang from '@/lang'
import { ArticleKinds } from '@/modules/base/util/constants'

const urls = {
  single: 'article',
  multiple: 'articles',
}

export default {
  quickfilters: [
    { name: 'all', title: lang.generics.allProperCase },
  ],

  salesVolumeUrl: 'article/getsalesvolumefromarticle',
  resourceUrl: `${config.resourceHost}article`,
  articlecategoryUrl: `${config.resourceHost}articlecategory`,
  articleunitUrl: `${config.resourceHost}articleunit`,
  nextArticleNumber: `${config.resourceHost}article/number`,
  articleImageUrl: `${config.resourceHost}article/image`,
  customFields: `${config.resourceHost}customfield`,

  articleListSetting: `${config.resourceHost}setting/userlist/article`,
  articleReportListSetting: `${config.resourceHost}setting/userlist/articleReport`,

  // image messages
  image: {
    minWidthMessage: lang.messages.common.imageUpload.minWidthMessage,
    minHeightMessage: lang.messages.common.imageUpload.minHeightMessage,
    maxWidthMessage: lang.messages.common.imageUpload.maxWidthMessage,
    maxHeightMessage: lang.messages.common.imageUpload.maxHeightMessage,
    fileTypeMessage: lang.messages.common.imageUpload.fileTypeMessage,
  },

  articleHistoryUrl: `${config.serviceHost}article/GetProcessesFromArticle`,
  articleHistoryQuickfilters: [
    { name: 'all', label: lang.generics.allProperCase },
    { name: 'offer', label: lang.generics.offers },
    { name: 'order', label: lang.generics.orders },
    { name: 'deliveryNote', label: lang.generics.deliveryNotes },
    { name: 'invoice', label: lang.generics.invoices },
    { name: 'cancellation', label: lang.generics.cancellations },
    { name: 'creditNote', label: lang.generics.creditNotes },
    { name: 'purchase', label: lang.generics.purchases },
  ],

  clientUrl: urls,

  routes: {
    details: (id) => `/${urls.multiple}/${id}`,
    list: `${config.resourceHost}${urls.multiple}`,
    new: `/${urls.multiple}/new`,
    edit: (id) => `/${urls.multiple}/edit/${id}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: ArticleKinds.SalesAndPurchase,
      title: lang.articleList.filters.salesAndPurchase,
      quickFilter: {
        kind: {
          type: 'set',
          values: [ArticleKinds.SalesAndPurchase],
        },
      },
    },
    {
      name: ArticleKinds.Sales,
      title: lang.articleList.filters.sales,
      quickFilter: {
        kind: {
          type: 'set',
          values: [ArticleKinds.Sales],
        },
      },
    },
    {
      name: ArticleKinds.Purchase,
      title: lang.articleList.filters.purchase,
      quickFilter: {
        kind: {
          type: 'set',
          values: [ArticleKinds.Purchase],
        },
      },
    },
  ],
}
